import styled from '@emotion/styled';
import { mediaQuery } from '@styles/index';
import { UpscTopicKeyFact } from './upscCurrentAffairsTopicTypes';

const FactsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 7px;

  ${mediaQuery.uptoMobile} {
    grid-template-columns: 1fr;
  }
`;

const FactCard = styled.div`
  padding: 10px 12px;
  border: 1px solid var(--color-divider);
  border-radius: 8px;
  background: var(--color-divider-secondary);
`;

const FactLabel = styled.div`
  margin-bottom: 3px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: var(--color-text-secondary);
`;

const FactValue = styled.div`
  font-size: 13.5px;
  font-weight: 600;
  color: var(--color-text-primary);
`;

export interface UpscTopicCardKeyFactsProps {
  keyFacts: UpscTopicKeyFact[];
}

const UpscTopicCardKeyFacts = ({ keyFacts }: UpscTopicCardKeyFactsProps) => (
  <FactsGrid>
    {keyFacts.map((fact) => (
      <FactCard key={`${fact.heading}-${fact.value}`}>
        <FactLabel>{fact.heading}</FactLabel>
        <FactValue>{fact.value}</FactValue>
      </FactCard>
    ))}
  </FactsGrid>
);

export default UpscTopicCardKeyFacts;
